import styled from 'styled-components';
import Icon from 'components/Icon';
import { themes } from 'styles/themes/wikifactoryNew';

export const GeometryStyled = styled.nav`
  padding: ${props => props.theme.spacing.default};
  overflow: auto;
  flex: 1;

  scroll-behavior: smooth;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const GeometryList = styled.ul`
  color: ${props => props.theme.color.greyDarker};
  font-size: ${props => props.theme.font.size.small};
`;

export const GeometryName = styled.span`
  color: ${themes.color.wfBlack};
  font-weight: ${props => props.theme.font.weight.xbold};
`;

export const TotalGeometries = styled.span`
  margin-left: 12px;
  color: ${themes.color.wfBlack};
`;

export const TotalSubGeometries = styled.span`
  margin-left: ${props => props.theme.spacing.xsmall};
  color: ${props =>
    props.selected ? themes.color.wfWhite : themes.color.wfBlack};
`;

export const SectionsListStyled = styled.ol`
  margin: ${props => props.theme.spacing.default} 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(${props => props.cols}, 1fr);
  grid-gap: ${props => props.theme.spacing.xsmall};
`;

const getBackgroundColor = props => {
  if (props.selected) {
    if (!props.highlighted) {
      return themes.color.wfBlue;
    }

    return props.theme.color.wfBlue700;
  }

  if (props.highlighted) {
    return themes.color.wfGrey100;
  }

  return 'transparent';
};

const getSvgStroke = () => `
  svg * {
    stroke: ${themes.color.wfWhite}
  }
`;

export const SectionStyled = styled.li`
  width: 100%;
  height: 100%;
  line-height: 0;
  padding: ${props => props.theme.spacing.xsmall};
  color: ${props =>
    props.selected ? themes.color.wfWhite : themes.color.wfBlack};
  background-color: ${props => getBackgroundColor(props)};
  border: 1px solid ${props => props.theme.color.wfGrey400};
  font-size: ${props => props.theme.font.size.xsmall};
  &:hover {
    cursor: pointer;
  }
  pointer-events: auto;

  ${props => {
    if (props.selected) {
      return getSvgStroke();
    }
  }}
`;

export const Navigation = styled.nav`
  background-color: ${props => props.theme.color.greyLightest};
  font-size: ${props => props.theme.font.size.small};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  position: relative;
  min-height: ${props => props.tabHeight}px;
`;

export const RowWrapper = styled.ul`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  height: ${props =>
    props.tabHeight ? `${props.tabHeight}px` : props.theme.spacing.large};
  padding: 0 ${props => props.theme.spacing.xsmall};
  font-weight: ${props => props.isSelected && props.theme.font.weight.xbold};
  border-bottom: ${props =>
    props.isSelected
      ? `1px solid ${props.theme.color.wfBlack}`
      : `1px solid transparent`};
  border-right: ${props =>
    !props.isLast && `1px solid ${props.theme.color.wfGrey200}`};
  &: ${props =>
    !props.isSelected &&
    `hover {
    cursor: pointer;
    border-bottom: ${`1px solid ${props.theme.color.wfGrey400}`};
  }`};
  pointer-events: auto;
`;

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  vertical-align: center;
  width: ${props => props.width ?? '100%'};
  height: 100%;
  color: ${themes.color.wfBlack};
  padding: 0 ${props => props.theme.spacing.small};
`;

export const NavText = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

export const IconStyled = styled(Icon)`
  height: 100%;
  width: ${props => props.theme.spacing.medium};
  color: ${props => props.theme.color.wfGrey800};
`;
